export default class Sale {
	constructor(creditCard, customer, installments) {
		this.creditCard = creditCard;
		this.customer = customer;
		this.installments = installments;
	}
}



// WEBPACK FOOTER //
// ./src/model/Sale.js